export default __webpack_public_path__ + "static/Satoshi-Medium-1ffe968245568e8ba1e766cec2c0075d.woff2";